import React, { useState } from "react";
import styled from "styled-components";

// Dummy templates set by admin
const defaultTemplates = [
    "Your request for repair has been received, Your job number is XXXXXXX.",
    "Thank you for reaching out. We'll get back to you shortly.",
    "Your request has been received. We will update you soon."
];

function MessageList() {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");

    // Function to send a custom message
    const handleSendMessage = () => {
        if (newMessage.trim()) {
            setMessages([...messages, { text: newMessage, sender: "User" }]);
            setNewMessage("");
        }
    };

    // Function to send a template message
    const handleTemplateMessage = (template) => {
        setMessages([...messages, { text: template, sender: "Admin Template" }]);
    };

    return (
        <Section>
            <div className="message-container">
                <h2>Messages</h2>
                <div className="message-list">
                    {messages.length > 0 ? (
                        messages.map((msg, index) => (
                            <div
                                key={index}
                                className={`message ${msg.sender === "User" ? "user" : "template"}`}
                            >
                                <span>{msg.text}</span>
                            </div>
                        ))
                    ) : (
                        <p className="no-messages">No messages yet.</p>
                    )}
                </div>

                <div className="input-section">
                    <input
                        type="text"
                        placeholder="Type your message..."
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                    />
                    <button onClick={handleSendMessage}>Send</button>
                </div>
            </div>

            <div className="template-container">
                <h3>Default Message Templates</h3>
                {defaultTemplates.map((template, index) => (
                    <button key={index} onClick={() => handleTemplateMessage(template)}>
                        {template}
                    </button>
                ))}
            </div>
        </Section>
    );
}

export default MessageList;

// ✅ Styled Components for Black & White Theme
const Section = styled.section`
  display: flex;
  gap: 2rem;
  padding: 2rem;
  background-color: #f5f5f5;
  color: black;

  .message-container {
    flex: 2;
    background: white;
    padding: 1.5rem;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

    h2 {
      margin-bottom: 1rem;
      font-size: 1.5rem;
    }

    .message-list {
      height: 300px;
      overflow-y: auto;
      margin-bottom: 1.5rem;
      border: 1px solid #ddd;
      padding: 1rem;
      border-radius: 8px;
      background: #fafafa;
    }

    .message {
      padding: 0.8rem;
      margin-bottom: 0.5rem;
      border-radius: 5px;
      font-size: 0.95rem;
    }

    .user {
      background: #000;
      color: white;
      text-align: right;
    }

    .template {
      background: #e0e0e0;
      color: black;
    }

    .no-messages {
      text-align: center;
      color: grey;
    }

    .input-section {
      display: flex;
      gap: 1rem;
      input {
        flex: 1;
        padding: 0.8rem;
        border-radius: 5px;
        border: 1px solid #ddd;
      }

      button {
        padding: 0.8rem 1.5rem;
        background: black;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }

  .template-container {
    flex: 1;
    background: white;
    padding: 1.5rem;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

    h3 {
      margin-bottom: 1rem;
      font-size: 1.2rem;
    }

    button {
      width: 100%;
      margin-bottom: 0.5rem;
      padding: 0.8rem;
      background: #000;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
  }
`;
